/* eslint-disable simple-import-sort/imports */
import React from "react";
import { useTranslation } from "react-i18next";

import useWorkerSchedulerData from "../../controllers/use-worker-scheduler-data";
import { STATUS, getAllowedTransitions } from "../../utils/transition-config";

export const useFilteredStatusOptions = (
	currentStatus: string,
	previousStatus?: string,
	onTransitionRequest?: (toStatus: string) => void
) => {
	const { schedulingStatusesObj } = useWorkerSchedulerData();
	const { t } = useTranslation();

	return React.useMemo(() => {
		const allowedTransitions = getAllowedTransitions(
			currentStatus,
			previousStatus
		);

		if (currentStatus === STATUS.CALLED_OFF && previousStatus) {
			return [
				{
					id: previousStatus,
					name: t("full-time-worker-scheduler_remove-time-off"),
					menuLabel: t("full-time-worker-scheduler_remove-time-off"),
					backgroundColor:
						schedulingStatusesObj[previousStatus]?.backgroundColor,
					textColor: schedulingStatusesObj[previousStatus]?.textColor,
					borderColor: schedulingStatusesObj[previousStatus]?.borderColor,
					onSelect: () => onTransitionRequest?.(previousStatus),
				},
			];
		}

		return allowedTransitions
			.filter((transition) => ((transition.toStatus !== currentStatus
        && currentStatus !== STATUS.REASSIGNED) || (
        currentStatus === STATUS.REASSIGNED
        && !["RAS", "TRA", "RDU"].includes(transition.toStatus)
      )))
			.map((transition) => ({
				id: transition.toStatus,
				name: schedulingStatusesObj[transition.toStatus]?.name,
				menuLabel:
					schedulingStatusesObj[transition.toStatus]?.code === "SCH"
						? t("full-time-worker-scheduler_scheduled-reset")
						: schedulingStatusesObj[transition.toStatus]?.name,
				backgroundColor:
					schedulingStatusesObj[transition.toStatus]?.backgroundColor,
				textColor: schedulingStatusesObj[transition.toStatus]?.textColor,
				borderColor: schedulingStatusesObj[transition.toStatus]?.borderColor,
				onSelect: () => onTransitionRequest?.(transition.toStatus),
			}));
	}, [
		currentStatus,
		previousStatus,
		onTransitionRequest,
		schedulingStatusesObj,
		t,
	]);
};
